__turbopack_context__.v({
  "activeDot": "offers-module__Hxbutq__activeDot",
  "badge": "offers-module__Hxbutq__badge",
  "carouselContainer": "offers-module__Hxbutq__carouselContainer",
  "carouselSlide": "offers-module__Hxbutq__carouselSlide",
  "carouselTrack": "offers-module__Hxbutq__carouselTrack",
  "content": "offers-module__Hxbutq__content",
  "ctaBtn": "offers-module__Hxbutq__ctaBtn",
  "description": "offers-module__Hxbutq__description",
  "dot": "offers-module__Hxbutq__dot",
  "dotsContainer": "offers-module__Hxbutq__dotsContainer",
  "offerBanner": "offers-module__Hxbutq__offerBanner",
  "offersSection": "offers-module__Hxbutq__offersSection",
  "title": "offers-module__Hxbutq__title",
});
